import { UniversalPage, Card, NotificationCard } from '@afrilink/ui';
import { ArrowLeftRight } from 'lucide-react';
import { DomainsBalanceBanner } from '../../components/DomainsBalanceBanner';

/**
 * AdminDomainsTransfersPage — NOT BUILT YET, and the page now says so first.
 *
 * F-10: this rendered "No transfers in flight" as the loudest text on the
 * screen, in `font-medium text-foreground`, with the "ships in Phase 8e.7"
 * caveat beneath it in muted grey. It fetches nothing — there is no query on
 * this page at all — so that sentence was a claim it had no way to make.
 *
 * It happened to be true (production currently holds zero rows with
 * `step = 'transfer'`), and it would have gone on being displayed with equal
 * confidence the day one existed. The page was also linked into the Domains
 * sub-nav on 2026-08-30 as one of the rescued orphans, so it now has readers.
 *
 * Inverted: the honest statement leads, the empty-state claim is gone entirely.
 * Real transfer tracking reads `domain_registration_order` where
 * `step = 'transfer'` and `status NOT IN ('complete','cancelled')`, plus the
 * registrar's `/domain/transfer/transferOutList` poll for outbound state.
 */
export default function AdminDomainsTransfersPage() {
  return (
    <UniversalPage
      title="Domain transfers"
      breadcrumbs={[
        { label: 'Admin', href: '/admin' },
        { label: 'Domains', href: '/admin/domains' },
        { label: 'Transfers' },
      ]}
    >
      <DomainsBalanceBanner />

      <NotificationCard
        tone="info"
        title="Transfer tracking is not built yet"
        body={
          <>
            This screen does not query anything, so it cannot tell you whether a
            transfer is in flight — treat it as unbuilt, not as empty. Until it
            ships, check <code>domain_registration_order</code> directly, or the
            registrar console for outbound transfers.
          </>
        }
      />

      <Card interactive={false} className="border-dashed p-12 text-center text-sm text-muted-foreground">
        <ArrowLeftRight className="mx-auto mb-3 h-8 w-8 text-muted-foreground/60" aria-hidden />
        <p className="font-medium text-foreground">Planned for Phase 8e.7</p>
        <p className="mt-1">
          The list will read{' '}
          <code className="mx-1 rounded-sm bg-muted px-1">domain_registration_order</code>
          rows where <code className="mx-1 rounded-sm bg-muted px-1">step = &apos;transfer&apos;</code>
          is still open, alongside the registrar&apos;s transfer-out poll.
        </p>
      </Card>
    </UniversalPage>
  );
}
